import React from 'react';
import PropTypes from 'prop-types';
import MarkdownRenderer from 'markdown-to-jsx';

// Read https://paypal.atlassian.net/wiki/x/UQK0Ow for more information on Markdown

const Markdown = ({ text }) => {
  return (
    <MarkdownRenderer options={{ disableParsingRawHTML: true, wrapper: React.Fragment }}>
      {text}
    </MarkdownRenderer>
  );
};

Markdown.propTypes = {
  text: PropTypes.string.isRequired
};

export default Markdown;
